var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42864 0.981445C0.639578 0.981445 0 1.43221 0 1.98834C0 2.54434 0.639578 2.99523 1.42864 2.99523H18.5714C19.3604 2.99523 20 2.54446 20 1.98834C20 1.43221 19.3604 0.981445 18.5714 0.981445H1.42864ZM1.42864 5.67999C0.639578 5.67999 0 6.13075 0 6.68688C0 7.24288 0.639578 7.69377 1.42864 7.69377H18.5714C19.3604 7.69377 20 7.243 20 6.68688C20 6.13075 19.3604 5.67999 18.5714 5.67999H1.42864ZM1.42864 10.3785C0.639578 10.3785 0 10.8293 0 11.3854C0 11.9414 0.639578 12.3923 1.42864 12.3923H18.5714C19.3604 12.3923 20 11.9415 20 11.3854C20 10.8293 19.3604 10.3785 18.5714 10.3785H1.42864Z",
    fill: "#B897E6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.7b268f7ecd087c018c0bae9e36bd75e6.svg";
export { ForwardRef as ReactComponent };